import BackIcon from "@/assets/svgs/back-icon";
import { Pressable, View } from "react-native";
import { useSlot, useStyled } from "use-styled";

const AppBarRoot = useStyled(View, {
  base: {
    className: "flex-row items-center pt-8 pb-4 gap-6 px-5",
    accessibilityRole: "button",
    style: {},
  },
  variants: {
    size: {},
    intent: {},
  },
  defaultVariants: {},
  compoundVariants: [],
});

const AppBarTitle = useStyled(View, {
  base: {
    className:
      "font-geologica-regular font-normal text-base text-black leading-[1.5]",
  },
});

const AppBarIcon = ({ onPress, pathClassName }: { onPress?: () => void, pathClassName?: string }) => (
  <Pressable
    onPress={onPress}
    accessibilityRole="button"
    className="h-[24px] w-[24px] justify-center items-center"
  >
    <BackIcon pathClassName={pathClassName} />
  </Pressable>
);

export const AppBar = useSlot(AppBarRoot, {
  Title: AppBarTitle,
  Icon: AppBarIcon,
});
